import type { LucideIcon } from 'lucide-react'

import {
    Anchor,
    Feather,
    Fish,
    FishSymbol,
    Package
} from 'lucide-react'

type CategoryStyle = {
    icon: LucideIcon
    tint: string
}

/*
 * Icon and background tint per category slug. A category added later in the
 * CMS falls back to the default style.
 */
const CATEGORY_STYLES: Record<string, CategoryStyle> = {
    'rods-reels': { icon: Fish, tint: 'bg-secondary' },
    'lures-bait': { icon: FishSymbol, tint: 'bg-accent/25' },
    'fly-fishing': { icon: Feather, tint: 'bg-lagoon/30' },
    'line-gear': { icon: Package, tint: 'bg-muted' }
}

const DEFAULT_STYLE: CategoryStyle = { icon: Anchor, tint: 'bg-secondary' }

export const getCategoryStyle = (slug: string | null | undefined): CategoryStyle => {
    if (!slug) return DEFAULT_STYLE

    return CATEGORY_STYLES[slug] ?? DEFAULT_STYLE
}
